import Header from "@/components/navigation/Header";
import TabMenu from "@/components/navigation/TabMenu";
import { DashboardParamsProviders } from "@/context/DashboardParamsProviders";
import { FieldCustomizationOverrideProvider } from "@/context/FieldCustomizationOverrideContext";
import { Outlet, useLocation } from "react-router";

const Dashboard = () => {
  const entity = useLocation().pathname.split("/")[2];

  const content = (
    <FieldCustomizationOverrideProvider>
      <div>
        <Header />
        <TabMenu>
          <Outlet />
        </TabMenu>
      </div>
    </FieldCustomizationOverrideProvider>
  );

  return entity ? (
    <DashboardParamsProviders key={entity} storageKey={entity}>
      {content}
    </DashboardParamsProviders>
  ) : (
    content
  );
};

export default Dashboard;
